/* Hush Haus fixes: put sleeves under their own Shop filter pill. Runs after theme.js. */
(() => {
  const cards = [...document.querySelectorAll('.hh-collection-grid > .hh-product-card')];
  if (!cards.length) return;
  let changed = false;
  cards.forEach((card) => {
    if (/sleeve/i.test(card.dataset.productType || '')) { card.dataset.categories = 'sleeves'; changed = true; }
  });
  const current = new URLSearchParams(window.location.search).get('category');
  if (changed && current) document.querySelector(`.hh-filter-pills a[data-collection-category="${current}"]`)?.click();
})();
